// extracted by mini-css-extract-plugin
export default {"gpa__mobile_footer_copyright_text":"CopyRight_gpa__mobile_footer_copyright_text__QyxAa"};